import React from 'react';

function ActivitySettings({
  activities,
  allActivities,
  expandedCategories,
  activityLoading,
  handleActivityToggle,
  handleSelectAll,
  handleDeselectAll,
  handleToggleCategory,
  handleSaveActivities,
  initialDataLoaded,
}) {
  return (
    <div className="activity-settings">
      <h3>Manage Activities</h3>
      <p className="goal-tagline">Choose which activities to display on your user page.</p>
      {!initialDataLoaded ? (
        <p className="loading">Loading...</p>
      ) : (
        <div>
          {Object.keys(allActivities).map(category => (
            <div key={category} className="category-section">
              <div className="category-header">
                <h4>{category.charAt(0).toUpperCase() + category.slice(1)}</h4>
                <div className="category-controls">
                  <div className="category-bulk-grid">
                    <button
                      className="btn-secondary"
                      onClick={() => handleSelectAll(category, 'home')}
                      disabled={activityLoading}
                      aria-label={`Select all ${category} home`}
                    >
                      All Home
                    </button>
                    <button
                      className="btn-secondary"
                      onClick={() => handleSelectAll(category, 'gym')}
                      disabled={activityLoading}
                      aria-label={`Select all ${category} gym`}
                    >
                      All Gym
                    </button>
                    <button
                      className="btn-secondary"
                      onClick={() => handleDeselectAll(category, 'home')}
                      disabled={activityLoading}
                      aria-label={`Deselect all ${category} home`}
                    >
                      None Home
                    </button>
                    <button
                      className="btn-secondary"
                      onClick={() => handleDeselectAll(category, 'gym')}
                      disabled={activityLoading}
                      aria-label={`Deselect all ${category} gym`}
                    >
                      None Gym
                    </button>
                  </div>
                  <button
                    onClick={() => handleToggleCategory(category)}
                    disabled={activityLoading}
                    className="toggle-category-button"
                    aria-label={expandedCategories[category] ? `Collapse ${category} category` : `Expand ${category} category`}
                  >
                    {expandedCategories[category] ? '\u2212' : '+'}
                  </button>
                </div>
              </div>
              {expandedCategories[category] && (
                <div className="activity-list activity-list--locations">
                  <div className="activity-list-header">
                    <span></span>
                    <span>Home</span>
                    <span>Gym</span>
                  </div>
                  {Object.keys(allActivities[category]).map(activity => (
                    <div key={activity} className="activity-row">
                      <span className="activity-row-name">{allActivities[category][activity]}</span>
                      <input
                        type="checkbox"
                        checked={activities[category]?.[activity]?.home || false}
                        onChange={() => handleActivityToggle(category, activity, 'home')}
                        disabled={activityLoading}
                        aria-label={`${allActivities[category][activity]} home`}
                      />
                      <input
                        type="checkbox"
                        checked={activities[category]?.[activity]?.gym || false}
                        onChange={() => handleActivityToggle(category, activity, 'gym')}
                        disabled={activityLoading}
                        aria-label={`${allActivities[category][activity]} gym`}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
          <button
            onClick={handleSaveActivities}
            disabled={activityLoading}
            className="save-activities-button btn-primary"
          >
            {activityLoading ? 'Saving...' : 'Save preferences'}
          </button>
        </div>
      )}
    </div>
  );
}

export default ActivitySettings;
